import { StyleSheet } from 'react-native';
import { PALETTE, TYPOGRAPHY } from '../../../../../../../src/constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
    paddingVertical: 6,
    display: 'block',
  },
  root2:{
    flexDirection: 'row',
    paddingVertical: 6,
    display: 'block',
  },
  itemLeft: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    float: 'left',
  },
   itemRight: {
    display: 'inline-flex',
    alignItems: 'flex-end',
    marginRight: 12,
    float: 'right'
  },
  itemSeparator: {
    width: 1,
    backgroundColor: PALETTE.secondaryText,
    marginVertical: 8,
    marginHorizontal: 20,
  },
  itemLabel: {
    color: PALETTE.primaryText,
  },
  itemValue: {
    color: PALETTE.secondaryActive,
  },
  marginValue: {
    marginTop: 10,
  },
  currencyBeforeNumber: {
      fontSize: TYPOGRAPHY.font.size.normal,
  }
});
